import { useBrandProfile } from '../contexts/brand-profile';
import { brandProfileOf } from './brandProfiles';

/**
 * Whether bilingual (中文 + English) labels apply to what is on screen right now.
 *
 * The active brand decides: BHCS is bilingual, Kaleido is English-only. Outside
 * `BrandProfileProvider` — the admin and teacher portals, which route above it —
 * `useBrandProfile` returns the default brand, which is bilingual.
 *
 * Every accessor in `useLabels.ts` goes through here, so the rule holds for labels, buttons,
 * statuses, billing types, program types, months and weekday dates at once, rather than being
 * re-decided per call site.
 *
 * Its own module so the test suite can pin it: `vitest.setup.ts` mocks it to English-only,
 * because component assertions across the suite are written against the English strings.
 */
export function useBilingualEnabled(): boolean {
  const { activeBrand } = useBrandProfile();
  return brandProfileOf(activeBrand).bilingual;
}
